
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RoutesListener = (): JSX.Element | null => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") {
      localStorage.setItem("isPlaying", "false");
      // localStorage.setItem("selectedSystemId", "1000");
      // localStorage.setItem("selectedAnimationId", "90001050");
    }

  }, [location.pathname]);

  return null; 
};

export default RoutesListener;
